import React from 'react';
import 'swiper/css';
import "swiper/css/navigation";
import styles from './DynamicAdCarousel.module.css';
import { Navigation, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Skeleton } from '@mui/material';

export default function DynamicAdCarousel(props) {

  return (
    <>
      <Swiper
        loop
        height={200}
        spaceBetween={10}
        navigation
        autoplay={{ delay: 2000, disableOnInteraction: true }}
        modules={[Navigation, Autoplay]}
        onSwiper={() => {}}
        slidesPerView={props.width >= 993 ? 2.1 : 1.1}
        onSlideChange={() => {}}
      >
        {props.adsLoading ?
          <SwiperSlide>
              <Skeleton className={styles.skeleton_placeholder} variant='rectangular' />
          </SwiperSlide>
        :
          props.ads?.map((ad, index) => {
            if (ad.active) {
              return (
                <SwiperSlide key={index}>
                  <div
                    className={styles.ad_container}
                    style={{ backgroundImage: `url(${ad.image})` }}
                    onClick={ad.link === '' ? () => {} : () => props.router.push(ad.link)}
                  >
                  </div>
                </SwiperSlide>
              );
            }
          })
          
        }
      </Swiper>
      </>
  );
}